ClickElseWhereMixin = require 'mixins/click-else-where'

PromiseQueue     = require 'utils/promise-queue'

App.SmChosenAddButtonComponent = Em.Component.extend ClickElseWhereMixin,
  classNames: [ 'sm-chosen-add-button' ]

  searchEnabled: true
  insertEnabled: true

  searchQuery:  ''
  currentIndex: -1

  isAddNewSelected: (->
    @get('currentIndex') >= @get('filteredSuggestions.length')
  ).property('currentIndex', 'filteredSuggestions.length')

  searchQueryIsNotEmpty: (->
    @get('searchQuery').length > 0
  ).property('searchQuery')

  showAddNew: (->
    # TODO:
    wasntAdded = true

    @get('searchQueryIsNotEmpty') and wasntAdded and @get('insertEnabled')
  ).property('searchQueryIsNotEmpty', 'insertEnabled')

  # ---
  # Подгрузка списка подсказок
  # ---

  suggestions: Em.A([])

  filteredSuggestions: (->
    @get('suggestions').filter (sug) =>
      @get('content').indexOf(sug) == -1
  ).property('content.[]', 'suggestions.[]')

  isLoading:   false

  # ---
  # Подгружает порцию предложений по запросу
  # ---
  fetchSuggestions: (query) ->
    if @get('onQueryAction')
      deferred = Em.RSVP.defer()
      @sendAction('onQuery', deferred, query)

      return deferred.promise


    if @get('collection') and Em.isArray( @get('collection') )
      labelPath = @get('labelPath')

      filtered = @get('collection').filter (item) =>
        return true if Em.isEmpty(query)

        value = Em.get(item, labelPath)
        value.toLowerCase().indexOf(query.toLowerCase(), 0) != -1

      return Em.RSVP.resolve(filtered)

    Em.RSVP.reject 'No way to query items'

  manualRefetch: 42
  promiseQueue: null

  _initPromiseQueue: (->
    @set('promiseQueue', PromiseQueue.create())

    @get('promiseQueue').on 'empty', =>
      @set('isLoading', false)
  ).on('init')

  refreshSuggestions: (->
    @get('promiseQueue').push 'query', =>
      @set('isLoading', true)
      @fetchSuggestions(@get('searchQuery'))
      .then (sug) =>
        @set('suggestions', sug)
        @set('currentIndex', -1)
      .finally =>
        # @set('isLoading', false)

  ).observes( 'manualRefetch')

  _debouncedRefetch: ->
    @notifyPropertyChange('manualRefetch')

  onSearchQueryChanged: (->
    Em.run.debounce(@, @_debouncedRefetch, 300)
  ).observes('searchQuery')

  # ---
  # Функции
  # ---
  onClickElsewhere: ->
    @set('isOpen', false)

  didInsertElement: ->
    @$('.sm-text-field').on('input', @onInputChange.bind(@))
    @on('keyDown', @, @interpretKeyEvents)

  willDestroyElement: ->
    @$('.sm-text-field').off('input', @onInputChange.bind(@))

  onInputChange: ->
    @set('searchQuery', @$('.sm-text-field').val().trim())

  # ---
  # Стрелки
  # ---
  interpretKeyEvents: (event) ->
    map =
      38: 'arrowUp'
      40: 'arrowDown'
      13: 'enterKey'

    method = map[event.keyCode]
    if method
      this[method](event)
    else
      @_super(event)

  arrowUp: (event) ->
    if @get('currentIndex') != 0
      @set('currentIndex', @get('currentIndex') - 1)

  arrowDown: (event) ->
    if @get('currentIndex') < @get('filteredSuggestions.length') - 1 or
       @get('currentIndex') == @get('filteredSuggestions.length') - 1 and @get('showAddNew')

      @set('currentIndex', @get('currentIndex') + 1)

  enterKey: (event) ->
    return if @get('currentIndex') == -1

    if @get('isAddNewSelected')
      @send('createNewItem')
    else
      @send('addItem', @get('filteredSuggestions').get(@get('currentIndex')))

  # ---
  # События
  # ---
  actions:
    openDropdown: ->
      @set('isOpen', true)

      @notifyPropertyChange('manualRefetch')

      if @get('searchEnabled')
        Em.run.next(=> @$('.sm-text-field').focus())
      false

    addItem: (item) ->
      @sendAction('onAddItem', item)
      false

    createNewItem: ->
      @sendAction('onCreateItem', @get('searchQuery'))
      false

    loadMore: ->
      @sendAction('onLoadMore', @get('searchQuery'))
      false

